import { CallsDataParams } from 'services/api/getCallsData';
import { GetLiveMonitorStatsParams } from 'services/api/getLiveMonitorStats';
import { GetQueueAlertsParams } from 'services/api/getQueueAlerts';
import { SMSDataParams } from 'services/api/getSMSData';
import { WorkflowPhoneNumbersParams } from 'services/api/getWorkflowPhoneNumbers';
import { GetSmsStatisticsParams } from '../api/getSmsStatistics';
import { DashboardDataParams } from '../api/getDashboardData';
import { UseGetAgenticWorkflowDetailsParams } from './queries/useGetAgenticWorkflowDetails';
import { GetContactsParams } from 'types/contact.type';

export const queryKeys = {
    smsManagement: ['smsManagement'],
    smsData: (params: SMSDataParams) => ['smsData', params],
    smsConversationMessages: (conversationId: string) => ['smsConversationMessages', conversationId],
    smsStatistics: (params: GetSmsStatisticsParams) => ['smsStatistics', params],
    dashboardData: (params: DashboardDataParams) => ['dashboardData', params],
    dashboardMetrics: (campaignId: string) => ['dashboardMetrics', campaignId],
    agenticWorkflows: ['agenticWorkflows'],
    agenticWorkflowDetails: (params: UseGetAgenticWorkflowDetailsParams) => ['agenticWorkflowDetails', params],
    liveMonitorStats: (params: GetLiveMonitorStatsParams) => ['liveMonitorStats', params],
    queueAlerts: (params: GetQueueAlertsParams) => ['queueAlerts', params],
    managerCenterData: ['managerCenterData'],
    managerAgentsAnalytics: ['managerAgentsAnalytics'],
    agentCenter: ['agentCenter'],
    callsData: (params: CallsDataParams) => ['callsData', params],
    customizePage: ['customizePage'],
    partyStages: ['partyStages'],
    accessManager: ['accessManager'],
    tenantWorkflows: ['tenantWorkflows'],
    twilioActiveAccounts: ['twilioActiveAccounts'],
    outboundTrunks: ['outboundTrunks'],
    // accountId omitted: the caller's own company.
    members: (accountId?: string) => ['members', accountId ?? 'own'],
    companies: ['companies'],
    people: ['people'],
    livekitRoomDetails: (callID: string) => ['livekitRoomDetails', callID],
    persistTranscript: (roomName?: string) => ['persistTranscript', roomName],
    contacts: (params: GetContactsParams) => ['contacts', params],
    contactDetails: (id: string) => ['contactDetails', id],
    qualifications: (callIds: string[]) => ['qualifications', callIds],
    aggregatedQualifications: (callIds: string[]) => ['aggregatedQualifications', callIds],
    editAgenticWorkflow: (id: string) => ['editAgenticWorkflow', id],
    prompts: ['prompts'],
    callbackHealth: ['callbackHealth'],
    callDispositions: ['callDispositions'],
    agentCenterAnalytics: ['agentCenterAnalytics'],
    tenantConfig: (tenantId: string) => ['tenantConfig', tenantId],
    tenantSmsPacing: (tenantId: string) => ['tenantSmsPacing', tenantId],
    workflowConfig: (id?: string) => ['workflowConfig', id],
    defaultStatusConfig: ['defaultStatusConfig'],
    transferAudio: (id?: string) => ['transferAudio', id],
    workflowPhoneNumbers: (params: WorkflowPhoneNumbersParams) => ['workflowPhoneNumbers', params],
    releaseProposals: (tenantId: string) => ['releaseProposals', tenantId],
};
